import Link from "next/link";
import React, { useEffect, useState } from "react";
import styles from "./Cookies.module.css";

const Cookies = () => {
  const [cookiesAccepted, setCookiesAccept] = useState(false);
  const handleCookies = (accept) => {
    setCookiesAccept(accept);
    localStorage.setItem("cookies", JSON.stringify(accept));
  };
  useEffect(() => {
    const cookies = localStorage.getItem("cookies");
    if (cookies) {
      setCookiesAccept(JSON.parse(cookies));
    } else {
      setCookiesAccept(null);
    }
  }, []);
  return (
    cookiesAccepted === null && (
      <div
        className={`${styles.fadeIn} fixed bottom-4 left-4 right-4 sm:right-auto sm:left-6 sm:bottom-6 z-[60] max-w-md bg-white/95 backdrop-blur-md rounded-2xl shadow-2xl border border-gray-100 p-4`}
      >
        <div className="flex items-start gap-3">
          <span className="text-2xl">🍪</span>
          <div className="flex-1">
            <p className="text-sm text-gray-700 leading-relaxed">
              We use cookies to enhance your experience.{" "}
              <Link
                href="/privacy-policy"
                className="text-[#915bff] hover:underline font-medium"
              >
                Learn more
              </Link>
            </p>
            <div className="flex gap-2 mt-3">
              <button
                onClick={() => handleCookies(true)}
                className="px-4 py-1.5 text-sm font-medium rounded-full bg-black text-white hover:bg-gray-800 transition-all"
              >
                Accept
              </button>
              <button
                onClick={() => handleCookies(false)}
                className="px-4 py-1.5 text-sm font-medium rounded-full border border-gray-300 text-gray-600 hover:bg-gray-100 transition-all"
              >
                Decline
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default Cookies;
